export default "__VITE_ASSET__ZIEjWJfK__"